import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardingModule } from './onboarding/onboarding.module';
import { DashboardModule } from './dashboard/dashboard.module';

@NgModule({
    imports: [CommonModule, OnboardingModule, DashboardModule],
    declarations: [],
})
export class PagesModule {}
